// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__1_5_4","enter":"Sidebar_enter__2UkVV","exit":"Sidebar_exit__259Sn","item":"Sidebar_item__3qWgw"};